import * as ProgressPrimitive from '@radix-ui/react-progress'
import React from 'react'

import { cn } from '../utils'

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn('relative h-4 w-full overflow-hidden rounded-full bg-secondary', className)}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="bg-primary h-full w-full flex-1 transition-all"
      // clampa em [0,100]: utilização observada pode passar de 100% (overcommit) e um
      // value>100 vira translateX positivo -> indicador sai do overflow-hidden -> barra
      // vazia (lê como 0% justo no mais carregado). O texto do % mostra o valor real.
      style={{ transform: `translateX(-${100 - Math.min(Math.max(value || 0, 0), 100)}%)` }}
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
